import { createFileRoute } from "@tanstack/react-router";
import { RelatorioEntradaLeite } from "pages/relatorios/pages/entrada_leite";

export const Route = createFileRoute("/a/relatorios/entrada-leite")({
	component: RelatorioEntradaLeite,
});
